module.exports = __webpack_public_path__ + "static/1.1.C. OLAR RANDARE 1-f2fc9e71e485e3a7dc0d87a5475fad33.jpg";